import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"refresh\"><defs><style>#refresh .cls-1{fill:none}</style></defs><title>资源 1</title><g id=\"refresh_图层_2\" data-name=\"图层 2\"><g id=\"refresh_Group_123\" data-name=\"Group 123\"><path id=\"refresh_Rectangle_43_Copy_10\" data-name=\"Rectangle 43 Copy 10\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"refresh_sync\"><path id=\"refresh_Shape\" d=\"M6.19 20.75A10.47 10.47 0 0 1 3 17.37v1.77a.74.74 0 0 1-1.48 0v-3.78a.75.75 0 0 1 .73-.74H6a.74.74 0 0 1 0 1.48H4a9 9 0 0 0 17-3.42.74.74 0 1 1 1.47.11 10.51 10.51 0 0 1-16.28 8zM2.21 12a.73.73 0 0 1-.68-.79A10.5 10.5 0 0 1 21 6.63V4.86a.74.74 0 1 1 1.48 0v3.78a.74.74 0 0 1-.74.73H18a.74.74 0 1 1 0-1.47h2a9 9 0 0 0-17 3.42.74.74 0 0 1-.74.68z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/refresh.svg
// module id = wK1c
// module chunks = 6